export default "__VITE_ASSET__Dqn5HROl__"